/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { GET_FIELD_TASK_COMPLETE_COUNT, FIELD_TASK_COMPLETE_RESPONSE } = constants.GetFieldTaskConstants;

export default {
    GET_FIELD_TASK_COMPLETE_COUNT,
    FIELD_TASK_COMPLETE_RESPONSE,

  requestFieldTaskCount: payload => ({
    type: GET_FIELD_TASK_COMPLETE_COUNT,
    payload
  }),
  fieldTaskCountReceived : () => ({
    type: FIELD_TASK_COMPLETE_RESPONSE
  }),
};
